import styled from '@emotion/styled';
import React, { useContext } from 'react';
import { Route, Switch } from 'react-router-dom';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import Context from './Context';
import List from './Routes/List';
import Record from './Routes/Record';
import Actions from './Routes/Actions';
import Sidebar from './Containers/Sidebar';
import MainContainer from './Containers/Main';
import HeaderContainer from './Containers/HeaderContainer';
import AddPopover from './Components/Popovers/Add';
import RollUpButton from './Components/RollUpButton';
import MainOuterContainer from './Containers/MainOuter';
import Header from './Components/Header/Header';
import BulkSelectHeader from './Components/Header/BulkSelect';
import MainActionButton from '~/App/Components/Buttons/MainAction';

const MainActionButtonContainer = styled.div`
  position: absolute;
  bottom: 15px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
`;

const MainActionButtonInner = styled.div`
  display: flex;
  justify-content: center;
`;

export default function Mobile() {
  const { bulkSelect, selectedGreets } = useContext(Context);

  return (
    <React.Fragment>
      <Switch>
        <Route exact path='/home/greet/:id'>
          <MainOuterContainer>
            <Actions />
            <MainContainer>
              <Record />
            </MainContainer>
          </MainOuterContainer>
        </Route>
        <Route path='/'>
          <Sidebar>
            <HeaderContainer>
              <Switch>
                {!bulkSelect.data.any || <Route component={BulkSelectHeader} />}
                <Route component={Header} />
              </Switch>
            </HeaderContainer>
            <List />
            {bulkSelect.data.any && (
              <MainActionButtonContainer>
                <MainActionButtonInner>
                  <RollUpButton greets={selectedGreets} />
                </MainActionButtonInner>
              </MainActionButtonContainer>
            )}
          </Sidebar>
        </Route>
      </Switch>
    </React.Fragment>
  );
}
